/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SeoMetaControllerGetMetaQueryResponse,
  SeoMetaControllerGetMetaPathParams,
  SeoMetaControllerGetMetaQueryParams,
  SeoMetaControllerGetMeta400,
  SeoMetaControllerGetMeta401,
  SeoMetaControllerGetMeta404,
} from '../../types/SeoMetaControllerGetMeta.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { seoMetaGetMeta } from '../../methods/seoMetaGetMeta.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const seoMetaGetMetaQueryKey = (
  pageType: SeoMetaControllerGetMetaPathParams['pageType'],
  params?: SeoMetaControllerGetMetaQueryParams,
) => [{ url: '/api/seo-meta/:pageType', params: { pageType: pageType } }, ...(params ? [params] : [])] as const;

export type SeoMetaGetMetaQueryKey = ReturnType<typeof seoMetaGetMetaQueryKey>;

export function seoMetaGetMetaQueryOptions(
  pageType: SeoMetaControllerGetMetaPathParams['pageType'],
  params?: SeoMetaControllerGetMetaQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = seoMetaGetMetaQueryKey(pageType, params);
  return queryOptions<
    SeoMetaControllerGetMetaQueryResponse,
    ResponseErrorConfig<SeoMetaControllerGetMeta400 | SeoMetaControllerGetMeta401 | SeoMetaControllerGetMeta404>,
    SeoMetaControllerGetMetaQueryResponse,
    typeof queryKey
  >({
    enabled: !!pageType,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return seoMetaGetMeta(pageType, params, config);
    },
  });
}

/**
 * {@link /api/seo-meta/:pageType}
 */
export function useSeoMetaGetMeta<
  TData = SeoMetaControllerGetMetaQueryResponse,
  TQueryData = SeoMetaControllerGetMetaQueryResponse,
  TQueryKey extends QueryKey = SeoMetaGetMetaQueryKey,
>(
  pageType: SeoMetaControllerGetMetaPathParams['pageType'],
  params?: SeoMetaControllerGetMetaQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        SeoMetaControllerGetMetaQueryResponse,
        ResponseErrorConfig<SeoMetaControllerGetMeta400 | SeoMetaControllerGetMeta401 | SeoMetaControllerGetMeta404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? seoMetaGetMetaQueryKey(pageType, params);

  const query = useQuery(
    {
      ...seoMetaGetMetaQueryOptions(pageType, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<SeoMetaControllerGetMeta400 | SeoMetaControllerGetMeta401 | SeoMetaControllerGetMeta404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
